/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Welcome_Feature_Ats_DescInputs */

const en_onboarding_welcome_feature_ats_desc = /** @type {(inputs: Onboarding_Welcome_Feature_Ats_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See how your resume scores before you apply`)
};

const de_onboarding_welcome_feature_ats_desc = /** @type {(inputs: Onboarding_Welcome_Feature_Ats_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sieh, wie dein Lebenslauf bewertet wird, bevor du dich bewirbst`)
};

const fr_onboarding_welcome_feature_ats_desc = /** @type {(inputs: Onboarding_Welcome_Feature_Ats_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vois comment ton CV est noté avant de postuler`)
};

const es_onboarding_welcome_feature_ats_desc = /** @type {(inputs: Onboarding_Welcome_Feature_Ats_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vea cómo califica su currículum antes de postularse`)
};

const it_onboarding_welcome_feature_ats_desc = /** @type {(inputs: Onboarding_Welcome_Feature_Ats_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vedi come viene valutato il tuo curriculum prima di candidarti`)
};

const nl_onboarding_welcome_feature_ats_desc = /** @type {(inputs: Onboarding_Welcome_Feature_Ats_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekijk hoe je CV scoort voordat je solliciteert`)
};

const pl_onboarding_welcome_feature_ats_desc = /** @type {(inputs: Onboarding_Welcome_Feature_Ats_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zobacz, jak Twoje CV jest oceniane przed aplikowaniem`)
};

const fi_onboarding_welcome_feature_ats_desc = /** @type {(inputs: Onboarding_Welcome_Feature_Ats_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Näe, kuinka ansioluettelosi pisteytyy ennen hakemista`)
};

const da_onboarding_welcome_feature_ats_desc = /** @type {(inputs: Onboarding_Welcome_Feature_Ats_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se, hvordan dit CV scorer, før du ansøger`)
};

const sv_onboarding_welcome_feature_ats_desc = /** @type {(inputs: Onboarding_Welcome_Feature_Ats_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se hur ditt CV betygsätts innan du ansöker`)
};

/**
* | output |
* | --- |
* | "See how your resume scores before you apply" |
*
* @param {Onboarding_Welcome_Feature_Ats_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const onboarding_welcome_feature_ats_desc = /** @type {((inputs?: Onboarding_Welcome_Feature_Ats_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Welcome_Feature_Ats_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_onboarding_welcome_feature_ats_desc(inputs)
	if (locale === "fr") return fr_onboarding_welcome_feature_ats_desc(inputs)
	if (locale === "es") return es_onboarding_welcome_feature_ats_desc(inputs)
	if (locale === "it") return it_onboarding_welcome_feature_ats_desc(inputs)
	if (locale === "nl") return nl_onboarding_welcome_feature_ats_desc(inputs)
	if (locale === "pl") return pl_onboarding_welcome_feature_ats_desc(inputs)
	if (locale === "fi") return fi_onboarding_welcome_feature_ats_desc(inputs)
	if (locale === "da") return da_onboarding_welcome_feature_ats_desc(inputs)
	if (locale === "sv") return sv_onboarding_welcome_feature_ats_desc(inputs)
	return en_onboarding_welcome_feature_ats_desc(inputs)
});